import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function CtaFinal() {
  return <section id="agendar" className="py-32 relative overflow-hidden bg-primary" data-id="element-33">
      {/* Strong Center Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(255,107,0,0.2) 0%, transparent 70%)'
    }} data-id="element-34" />

      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-35" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-36">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-accent text-sm font-bold tracking-widest uppercase mb-6 block" data-id="element-37">
          RESERVÁ TU LUGAR
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-5xl md:text-6xl lg:text-7xl font-heading font-black text-white mb-4 leading-tight" data-id="element-38">
          AGENDA TU SESIÓN DE CRECIMIENTO
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-3xl md:text-4xl font-bold text-gradient mb-8" data-id="element-39">
          Estratégica Gratuita
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-text-secondary text-xl max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-40">
          En 60 minutos analizamos tu negocio en profundidad y te presentamos
          cómo implementar el Sistema de Demanda Sostenida para escalar tu
          facturación.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-41">
          <a href="#calendly-embed" className="inline-flex items-center justify-center px-12 py-5 text-xl font-bold rounded-xl text-white bg-accent glow-button-strong mb-6 w-full sm:w-auto" data-id="element-42">
            Quiero mi sesión gratuita
          </a>
          <p className="text-gray-500 text-sm" data-id="element-43">
            Sin compromiso. Solo para dueños gastronómicos serios.
          </p>
        </motion.div>

        {/* Calendly Placeholder */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} id="calendly-embed" className="mt-16 bg-[#111] border border-accent/30 rounded-2xl p-2 md:p-4 shadow-2xl overflow-hidden" data-id="element-44">
          <iframe src="https://calendly.com/joaquineliasgonzalezparedes/60min?month=2026-05&date=2026-05-21&background_color=111111&text_color=ffffff&primary_color=FF6B00" title="Agenda tu sesión gratuita con Joaquín González Paredes" className="w-full rounded-xl border-0" style={{
          minHeight: '720px'
        }} loading="lazy" data-id="element-45" />
        </motion.div>
      </div>
    </section>;
}